module.exports = __webpack_public_path__ + "static/media/fire.3dc33621.gif";